import * as React from "react";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export const CardComparisonBenefitsTitleEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  const [benefitsTitle] = React.useMemo(() => items.map((item) => decorateEditorialHtml(item.text)), []);

  return (
    <div className="xl-l-padding-twelve l-l-padding-twelve m-x-padding-twelve xl-l-margin-six l-l-margin-six m-x-margin-twelve">
      <UitkText size={400} weight="bold">
        <div dangerouslySetInnerHTML={benefitsTitle} className="all-b-padding-six" />
      </UitkText>
    </div>
  );
};

export default CardComparisonBenefitsTitleEditorial;
